import { Box, FormControl, FormLabel, IconButton } from '@mui/material';
import Iconify from '../iconify';

interface ImageFieldProps {
  value: any;
  onChange: (event: any) => void;
  onRemove: (name: string) => void;
  label: string;
  name: string;
}

export const ImageField = ({
  value,
  onChange,
  onRemove,
  label,
  name,
}: ImageFieldProps) => {
  return (
    <FormControl>
      <FormLabel id={`${name}-label`}>{label}</FormLabel>
      {value && value !== 'null' ? (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            id={`${name}`}
            style={{
              margin: '0 auto',
              width: 100,
              background: 'grey',
            }}
            alt='tile'
            src={value}
          />

          <IconButton
            color='primary'
            aria-label='remove picture'
            component='button'
            onClick={() => onRemove(name)}
          >
            <Iconify
              icon='eva:trash-outline'
              sx={{
                color: 'error.main',
                width: 20,
                height: 20,
                cursor: 'pointer',
              }}
            />
          </IconButton>
        </Box>
      ) : (
        <IconButton
          color='primary'
          aria-label='upload picture'
          component='label'
          sx={{ width: 40, height: 40 }}
        >
          <input
            id={`${name}_input`}
            hidden
            accept='image/*'
            type='file'
            onChange={onChange}
          />
          <Iconify icon={'eva:upload-outline'} />
        </IconButton>
      )}
    </FormControl>
  );
};
